import lodashForEach from 'lodash.foreach';

/**
 * This is a port of the lodash forEach function.
 * We're porting this because it supports objects and arrays.
 * Ultimately we want to use the native forEach function, but for now we're
 * using this because the data types are unclear in the few places we use it.
 */
export const forEach = lodashForEach;
